import { render, staticRenderFns } from "./MainNavMenu.vue?vue&type=template&id=42bb51b8&scoped=true&"
import script from "./MainNavMenu.vue?vue&type=script&lang=js&"
export * from "./MainNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainNavMenu.vue?vue&type=style&index=0&id=42bb51b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb51b8",
  null
  
)

export default component.exports